import { STAGE_IDS, type StageId } from "@seeing-maths/contracts";

const LABELS: Record<StageId, string> = {
  notice: "Notice",
  play: "Play",
  predict: "Predict",
  name: "Name",
  solve: "Solve",
  explain: "Explain",
  transfer: "Far door",
};

export interface StageRailProps {
  current: StageId;
  maxReached: number;
  onSelect: (stage: StageId) => void;
}

export function StageRail({ current, maxReached, onSelect }: StageRailProps) {
  const currentIndex = STAGE_IDS.indexOf(current);
  return (
    <nav className="stage-rail" aria-label="Journey stages">
      {STAGE_IDS.map((stage, index) => {
        const disabled = index > maxReached;
        return (
          <button
            type="button"
            key={stage}
            className={`stage-step ${index < currentIndex ? "is-past" : ""}`}
            disabled={disabled}
            aria-current={stage === current ? "step" : undefined}
            onClick={() => onSelect(stage)}
          >
            <span className="stage-dot" aria-hidden="true" />
            <span>{LABELS[stage]}</span>
          </button>
        );
      })}
    </nav>
  );
}
